import React from "react"
import { DecoratorNode, LexicalNode, SerializedLexicalNode, Spread } from "lexical"

export type SerializedQuestionNode = Spread<
  {
    question_key: string
    question_label: string
  },
  SerializedLexicalNode
>

export class QuestionNode extends DecoratorNode<React.JSX.Element> {
  __question_key: string
  __question_label: string

  static getType(): string {
    return "question"
  }

  static clone(node: QuestionNode): QuestionNode {
    return new QuestionNode(node.__question_key, node.__question_label, node.getKey())
  }

  constructor(question_key: string, question_label: string, nodeKey?: string) {
    super(nodeKey)
    this.__question_key = question_key
    this.__question_label = question_label
  }

  createDOM(): HTMLElement {
    const element = document.createElement("div")
    element.className = "question-decorator-wrapper"
    element.style.display = "block"
    return element
  }

  updateDOM(prevNode: QuestionNode): boolean {
    return prevNode.__question_label !== this.__question_label
  }

  decorate(): React.JSX.Element {
    return (
      <QuestionComponent
        questionKey={this.__question_key}
        questionLabel={this.__question_label}
        nodeKey={this.getKey()}
      />
    )
  }

  getQuestionKey(): string {
    return this.__question_key
  }

  getQuestionLabel(): string {
    return this.__question_label
  }

  isInline(): boolean {
    return false
  }

  exportJSON(): SerializedQuestionNode {
    return {
      ...super.exportJSON(),
      question_key: this.__question_key,
      question_label: this.__question_label,
      type: "question",
    }
  }

  static importJSON(serializedNode: SerializedQuestionNode): QuestionNode {
    const { question_key, question_label } = serializedNode
    return $createQuestionNode(question_key, question_label)
  }
}

export function $createQuestionNode(question_key: string, question_label: string): QuestionNode {
  return new QuestionNode(question_key, question_label)
}

export function $isQuestionNode(node: LexicalNode | null | undefined): node is QuestionNode {
  return node instanceof QuestionNode
}

function QuestionComponent({
  questionKey,
  questionLabel,
  nodeKey,
}: {
  questionKey: string
  questionLabel: string
  nodeKey: string
}) {
  return (
    <h3
      className="question-node mt-4 mb-1 ml-0.5 border-l-2 pl-2"
      data-question-node="true"
      data-node-key={nodeKey}
      data-question-key={questionKey}
      data-question-label={questionLabel}
      style={{
        fontSize: "1.25rem",
        fontWeight: 600,
        lineHeight: "1.75rem",
        cursor: "pointer",
      }}
    >
      {questionLabel}
    </h3>
  )
}
